import { Card } from '@repo/ui/components'

export const DashboardSquareTokenWaysSkeleton = () => {
  return (
    <Card
      className='p-md md:p-lg flex flex-col justify-between h-full rounded-t-none sm:rounded-t-md'
      style={{
        boxShadow:
          '0px 2px 8px -2px var(--color-black-5), 0px 1px 2px 0px var(--color-black-5)',
      }}
    ></Card>
  )
}
